export default __webpack_public_path__ + "static/aikido-tilen-ac30270cf34b7a3d865c9bdfad995cc1.jpg";